import { OCTOBER } from "../content/october";

/**
 * Swarved Mahamandir, closing the register and events pages. One wide
 * photograph with its caption; nothing else competes with it.
 */
export function Mahamandir({ className = "" }: { className?: string }) {
  const { src, alt, caption } = OCTOBER.mahamandir;
  return (
    <figure className={className}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="aspect-[16/10] w-full rounded-2xl object-cover shadow-soft"
      />
      <figcaption className="mt-3 text-sm text-ink-soft">{caption}</figcaption>
    </figure>
  );
}
